import { usePropertyDetailViewModel } from './usePropertyDetailViewModel'
import { usePropertyBookmark } from './usePropertyBookmark'

// Facade — composes the view-model and bookmark composables for full-page
// consumers (PropertyDetailContainer) that need both. Consumers that only
// need the view-model (e.g. InvestDrawerContainer, which doesn't bookmark)
// can call usePropertyDetailViewModel directly. Public surface preserved
// for any cross-module consumers via @modules/offerings.
export const usePropertyDetail = (propertyId: string) => {
  const viewModel = usePropertyDetailViewModel(propertyId)
  const bookmark = usePropertyBookmark(propertyId, viewModel.raw)
  return { ...viewModel, ...bookmark }
}
